require('../../../node_modules/bootstrap/dist/css/bootstrap.min.css');
import AppHeader from '../AppHeader'
import AppFooter from '../AppFooter'

export default {
  name: 'app',
  created: function() {
    if (!this.$store.getters.isLogin && window.localStorage.getItem('access_token')) {
      this.authorize()
    }
  },
  components: {
    AppHeader,
    AppFooter
  },
  methods: {
    authorize: function() {
      this.$store.dispatch('AUTHORIZE')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/other.js